/**
 * AI-generated code, moderated by lzygmanski
 */
import dayjs from 'dayjs';
import {useTranslation} from 'react-i18next';

import {Typography} from '@/components/ui/typography';
import {TIME_FORMATS} from '@/utils/timeFormats';

export type AmbulancePrintPersonalInfoProps = {
  name: {firstName: string; lastName: string; middleName?: string | null};
  personalNumber: string;
  dateOfBirth: string;
};

const AmbulancePrintPersonalInfo = ({
  name,
  personalNumber,
  dateOfBirth,
}: AmbulancePrintPersonalInfoProps) => {
  const {t} = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      <Typography variant="h2" asChild className="text-lg font-semibold">
        <h2>{t('Personal information')}</h2>
      </Typography>
      <div className="grid grid-cols-2 gap-4">
        <div className="print:break-inside-avoid">
          <Typography className="text-sm font-medium">{t('Name')}:</Typography>
          <Typography>
            {name.firstName} {name.middleName} {name.lastName}
          </Typography>
        </div>
        <div className="print:break-inside-avoid">
          <Typography className="text-sm font-medium">
            {t('Personal number')}:
          </Typography>
          <Typography>{personalNumber}</Typography>
        </div>
        <div className="print:break-inside-avoid">
          <Typography className="text-sm font-medium">
            {t('Date of birth')}:
          </Typography>
          <Typography>
            {dayjs(dateOfBirth).format(TIME_FORMATS.date)}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default AmbulancePrintPersonalInfo;
